import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(5, 29, 73)',
      contrastText: '#fff',
    },
    background: {
      default: '#fff',
      paper: '#fff',
      header: 'rgb(5, 29, 73)',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgb(5, 29, 73)',
        },
      },
    },
  },
});

export default theme; 